import React from 'react';

export default () => (
  <svg width="21" height="21" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M1 0h20v20H1z" />
      <g
        transform="translate(1 .833)"
        stroke="#FFF"
        strokeLinejoin="round"
        className="icon-svg-info-stroke">
        <circle strokeLinecap="round" cx="9.583" cy="9.583" r="9.167" />
        <path strokeLinecap="round" d="M7.917 7.917h1.666V15" />
        <path d="M9.167 4.167a.417.417 0 1 0 0 .833.417.417 0 0 0 0-.833z" />
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/javascripts/svg/icon-info.es6.js